<template>
  <div class="bg-sub">
    <div class="container header-page">
      <mdb-card class="card-profile">
        <mdb-card-body class="card-body-profile">
          <div class="header-profile">
            <h2 class="text-center">แก้ไขข้อมูลส่วนตัว</h2>

              <!--h1>Upload images</h1>
              <div class="dropbox">
                <input type="file" name="file" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                accept="image/*" class="input-file">
              </div-->

            <div class="avatar-upload1 ">
              <div class="avatar-edit1 ">
                <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" name="file" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length">
                <label for="imageUpload"></label>
              </div>
              <div class="avatar-preview1">
                <!--div id="imagePreview"></div-->
                <img id="imagePreview">
              </div>
            </div>

            <div class="form-profile">
              <!--span class="is-success">{{alertUpdate}}</span-->
              <div v-if="alertUpdate" class="alert alert-success alert-dismissible fade show" role="alert">
                <span class="text-alert">แก้ไขข้อมูลส่วนตัวเรียบร้อยแล้ว !</span>
              <button type="button" @click="alertUpdate=false" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              </div>

              <div class="text-box">
                <label class="text-label">อีเมล</label>
                <input type="text" class="form-control" name="email" v-model="account.email" placeholder="อีเมล์" label="อีเมล์" readonly/>
              </div>


              <label class="text-label">ชื่อและนามสกุล</label>
              <mdb-row>
                <mdb-col>
                  <div class="text-box">
                    <input type="text" v-validate="'required'" name="name" class="form-control" v-model="account.firstname" placeholder="ชื่อ" label="ชื่อ" :class="{ 'is-invalid': errors.has('name') }"/>
                    <span class="help is-danger">{{ errors.first('name') }}</span>
                  </div>
                </mdb-col>

                <mdb-col>
                  <div class="text-box">
                    <input type="text" v-validate="'required'" name="lastname" class="form-control" v-model="account.lastname" placeholder="นามสกุล" label="นามสกุล" :class="{ 'is-invalid': errors.has('lastname') }"/>
                    <span class="help is-danger">{{ errors.first('lastname') }}</span>
                  </div>
                </mdb-col>
              </mdb-row>

            </div>

            <div class="text-center footer-card-profile">
              <btn class="btn-update-account" color="primary" @click="Update()" :disabled="errors.any()">บันทึกการแก้ไข</btn>
              <btn class="btn-update-account" color="red" @click="$router.push('/remove')" >ลบข้อมูลผู้ใช้งาน</btn>
            </div>

            <div class="text-center footer-card-profile">
             
            </div>

          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
  </div>

</template>

<script>
import { upload } from '../file-upload';
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
const formData = new FormData();
import { mdbCarousel, mdbCarouselItem, mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbBtn, mdbInput, Btn, mdbCol, mdbRow } from 'mdbvue';

export default {
  name: 'ProfilePage',
  components: {
    mdbCarousel,
    mdbCarouselItem,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbBtn,
    Btn,
    mdbInput,
    config,
    mdbRow,
    mdbCol
  },
  data() {
    return {
      account: {},
      thumb: null,
      alertUpdate: false,
      thumbUser: '',
      ShowUser: ''
    };
  },
  mounted() {
    this.Account();
    this.ToggleLogin();
    localStorage.pincode = '';
    this.Session();
  },
  methods: {
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    },
    filesChange(fieldName, fileList) {

      if (!fileList.length) return;

      var reader = new FileReader();
      reader.onload = function(){
        var dataURL = reader.result;
        var output = document.getElementById('imagePreview');
        output.src = dataURL;
      };
      reader.readAsDataURL(fileList[0]);

      var datetimestamp = Math.floor(new Date().getTime()/1000.0);
      this.fileImage = datetimestamp +'.'+(fileList[0].name.split('.')[fileList[0].name.split('.').length -1]);

      Array.from(Array(fileList.length).keys())
        .map(x => {
          formData.append('email', this.account.email);
          formData.append('file', fileList[0], this.fileImage);
        });
    },
    Save(formData) {
      upload(formData)
        .then(x => {
          console.log(x);
          formData.delete('file');
          this.thumb = x.name;
        });
    },
    Account() {
      let APIgetAccount = Host + '/api/v1/member/account';
      axios.post(APIgetAccount , {
        email: localStorage.emailfront
      }).then(response => {
        this.account = response.data.result;
        if (!this.account.thumb || this.account.thumb == "") {
          this.account.thumb = config.app.Thumb + '/cdn/images/default.png';
        }
        document.getElementById('imagePreview').src = this.account.thumb;
        //console.log(this.account);
      });
    },
    Update() {
      let APIgetUpdate = Host + '/api/v1/member/update';
      var data = {
        email: this.account.email,
        firstname: this.account.firstname,
        lastname: this.account.lastname
      };
      axios.post(APIgetUpdate , data).then(response => {
        this.Save(formData , this.account.email);
        this.alertUpdate = true;
        setTimeout(function () {
          location.reload();
        }, 3000);
      });
    },
    Thumbnail() {
      let APIgetThumbnail = Host + '/api/v1/member/thumb';
      var data = {
        email: this.account.email,
        thumb: this.thumb
      };
      axios.post(APIgetThumbnail , data).then(response => {
        this.Account();
      });
    }
  }
};
</script>

<style>
</style>
